import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {
  ref, toRefs, Ref, computed,
} from 'vue';
import { Account, AccountPresenter } from '@/models';
import { AccountAddress, toPublicKeyAsString } from '@/utils';
import { fetchAccount } from '@/api';


export default /*#__PURE__*/_defineComponent({
  props: {
    address: null,
    name: null
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as {
  address: AccountAddress,
  name?: string,
}




const { address, name } = toRefs(props);
const loading = ref(false);
const account: Ref<Account | null> = ref(null);
const presenter: Ref<AccountPresenter | null> = ref(null);
const addressAsString = computed(() => toPublicKeyAsString(address.value));

(async () => {
  try {
    loading.value = true;
    account.value = await fetchAccount(address.value);
    presenter.value = account.value ? new AccountPresenter(account.value) : null;
    // TODO: Handle null but recognised accounts like System Program which would be displayed as "Account Not Found" right now.
  } finally {
    loading.value = false;
  }
})();

return (_ctx: any,_cache: any) => {
  const _component_account_icon = _resolveComponent("account-icon")!
  const _component_account_card = _resolveComponent("account-card")!

  return (loading.value)
    ? (_openBlock(), _createBlock(_component_account_card, {
        key: 0,
        name: _unref(name) ?? 'Loading...',
        publicKey: _unref(addressAsString),
        disabled: ""
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_account_icon, { state: "loading" })
        ]),
        _: 1
      }, 8, ["name", "publicKey"]))
    : (presenter.value)
      ? (_openBlock(), _createBlock(_component_account_card, {
          key: 1,
          presenter: presenter.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click', $event)))
        }, null, 8, ["presenter"]))
      : (_openBlock(), _createBlock(_component_account_card, {
          key: 2,
          name: "Account Not Found",
          publicKey: _unref(addressAsString),
          disabled: ""
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_account_icon, { state: "error" })
          ]),
          _: 1
        }, 8, ["publicKey"]))
}
}

})